module.exports = __webpack_public_path__ + "img/helyspecifikus_szolgaltatasok.45f43475.png";